import Vue from "vue";
import UIkit from "uikit";
import UIkitIcons from "uikit/dist/js/uikit-icons";
//import Header from "./components/Header.vue";
// import Footer from "./components/Footer.vue";
//import Navigate from "./components/Navigate.vue";
//import Mobi from "./components/Mobi.vue";
import store from './store';
import "./assets/scss/utmb-sitefinity.scss";
import "./assets/js/utmb-web.js";
import "./assets/js/utmb/navigate-menu.js";
import "./assets/js/utmb/search-handler.js";
import "./assets/js/utmb/alert-system.js";
import "./assets/js/utmb-sitefinity.js";
import "./assets/js/utmb/photo-figure.js";
import "./assets/js/utmb/btn-back-to-top-sticky.js";
import "./assets/js/utmb/open-modal-via-hashtag.js";
import "./assets/js/sitefinity/forms-required-fields.js"
import "./assets/js/uikit/nav-accordion.js";
import "./assets/js/vendor/splide.min.js";

Vue.config.productionTip = false;
UIkit.use(UIkitIcons);

Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    htmlUnescape: str => str.replace(/&quot;/g, '"')
                            .replace(/&#39;/g, "'")
                            .replace(/&lt;/g, '<')
                            .replace(/&gt;/g, '>')
                            .replace(/&amp;/g, '&')
                            .replace(/&#8217;/g, "'")
                            .replace(/&nbsp;/g, " ")
  }
});

// new Vue({
//   store,
//   render: h => h(Header)
// }).$mount("#header");

// if (window.utmbWeb.useFooter) {
//   new Vue({
//     store,
//     render: h => h(Footer)
//   }).$mount("#footer");
// }

// if (window.utmbWeb.useNavigateMenuSitefinityApi) {
//   new Vue({
//     store,
//     render: h => h(Navigate)
//   }).$mount("#navigate");
// }

// if (window.utmbWeb.useMobileMenu) {
//   new Vue({
//     store,
//     render: h => h(Mobi)
//   }).$mount("#mobi");
// }
